import { TNextStepArguments, TStep } from '../../../types/form';
import { TCurrentQuestionEnhanced, TQuestionMap } from '../types/internal';
import { mergeWith } from 'ramda';

interface IParams {
  currentStep: TStep;
  currentStepArgs?: TNextStepArguments | null;
  questionsMap: TQuestionMap;
}

/**
 * Собирает составляющие части вопроса в единый объект TCurrentQuestionEnhanced
 * */
export const prepareCurrentQuestion = (params: IParams): TCurrentQuestionEnhanced => {
  const { currentStep, currentStepArgs, questionsMap } = params;
  /**
   * Объект вопроса обогощается доп.аргументами, которые прокидываются из шага (nextStep -> nextStepArgs)
   * mergeWith применен, чтоб не потерять аргументы из _currentQuestion, если в currentStepArgs они же имеют знач. null
   * к примеру, если в _currentQuestion верный title, а в currentStepArgs {title: null}, то title сохранится из _currentQuestion
   * */
  const questionBase = questionsMap[currentStep.questionCode];
  const questionWithArgsFromStep = mergeWith((l, r) => r || l, questionBase, currentStepArgs || {});

  return Object.assign(questionWithArgsFromStep, {
    required: currentStep.required,
    extras: currentStep.extras,
  });
};
